


<div class="container mx-auto d-flex flex-column-reverse flex-lg-row gap-3">

    <form class="form-box mb-5 my-lg-5 p-4 w-100" [formGroup]="form">


        <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label">{{"Address" | translate}}</label>
            <input type="email" class="form-control" id="exampleFormControlInput1" formControlName="title">
        </div>

        <div class="mb-3">
            <label for="exampleFormControlTextarea1" class="form-label">{{"Message" | translate}}</label>
            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" style="height: 200px; resize: none;" formControlName="message"></textarea>
        </div>


        <div class="mb-3">
            <button type="button" class="btn btn-warning" (click)="open_ticket();">{{"Open ticket" | translate}}</button>
        </div>


    </form>

    <div>

        <div class="d-flex justify-content-center">
            <img src="../../assets/images/create_ticket.svg" alt="ecommerce image" class="cover-img">
        </div>

    </div>

</div>
